import { Users, Plane, GraduationCap, History, Heart, Bus } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { IMG } from "../data/content";

const AUDIENCES = [
    {
        icon: Users,
        title: "Families",
        text: "Dress-up, stories and interactive learning that keep young visitors wide-eyed.",
    },
    {
        icon: Plane,
        title: "Tourists",
        text: "A cultural anchor among the many things to do in George Town — about ninety minutes, right in the heritage zone.",
    },
    {
        icon: GraduationCap,
        title: "Students",
        text: "Living history lessons across art, craft, technology and tradition.",
    },
    {
        icon: History,
        title: "History Lovers",
        text: "Penang's Indian story told through original objects, portraits and documents.",
    },
    {
        icon: Heart,
        title: "Culture Enthusiasts",
        text: "Tanjore painting, Nagarathar heritage and traditional arts explored in depth.",
    },
    {
        icon: Bus,
        title: "Group Visits",
        text: "Hosted journeys for schools, tour groups and cultural societies — arranged at booking.",
    },
];

const VisitorExperience = () => (
    <section id="experience" data-testid="visitor-experience-section" className="bg-heritage-parchment py-24 md:py-36">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <div className="grid gap-16 lg:grid-cols-[1fr_1.1fr] lg:items-center">
                <Reveal>
                    <Eyebrow>Visitor Experience</Eyebrow>
                    <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-ink sm:text-4xl lg:text-5xl">
                        For Every <em className="text-heritage-terra">Curious</em> Visitor
                    </h2>
                    <p className="mt-7 text-base leading-relaxed text-heritage-ink/75">
                        A visit to IHCC is a hosted journey of roughly ninety minutes through seven
                        experience zones — from sari dress-up and Penang Indian history to rare
                        artefacts, vintage technology, the vintage shop, Nagarathar heritage and the
                        Seeking &amp; Learning Hall — guided in English, Malay, Chinese and
                        Indonesian.
                    </p>
                    <div className="group relative mt-10 overflow-hidden rounded-2xl">
                        <img
                            src={IMG.sari}
                            alt="A guest trying traditional Indian attire at the IHCC sari dress-up experience in George Town, Penang"
                            className="h-[300px] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05] md:h-[360px]"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-heritage-ink/50 via-transparent to-transparent" />
                        <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-heritage-parchment/90">
                            Sari &amp; Traditional Dress-Up
                        </p>
                    </div>
                </Reveal>

                <div data-testid="visitor-audiences-list" className="grid gap-4 sm:grid-cols-2">
                    {AUDIENCES.map((a, i) => (
                        <Reveal key={a.title} delay={0.06 * i}>
                            <div className="group h-full rounded-2xl border border-heritage-terra/12 bg-heritage-cream p-6 transition-all duration-500 hover:-translate-y-1 hover:border-heritage-terra/30">
                                <a.icon
                                    size={22}
                                    strokeWidth={1.6}
                                    className="text-heritage-terra transition-transform duration-500 group-hover:scale-110"
                                />
                                <h3 className="mt-4 font-serif text-xl font-semibold text-heritage-ink">
                                    {a.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-heritage-ink/70">
                                    {a.text}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default VisitorExperience;
